


































































































































































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';

import Toast from '@/mixins/toast';
import { EventBus, MM_APPLY_ASSIGNMENT_FILTERS } from '@/mixins/event-bus';
import Card from '@/components/UI/Card.vue';
import CollapseCard from '@/components/UI/CollapseCard.vue';
import ColumnTitleContent from '@/components/UI/Table/ColumnTitleContent.vue';
// Импорт ради Array.prototype.realValuesOrEmpty() в зонных фильтрах
import '@/extensions';

import MmErrorsPanel from '../../components/MmErrorsPanel.vue';
import MmFileUpload from '../../components/MmFileUpload.vue';
import MmHintedButton from '../../components/MmHintedButton.vue';
import MmStates from '../../components/MmStates.vue';
import MmTable from '../../components/MmTable.vue';
import MmZoneSelect from '../../components/MmZoneSelect.vue';
import AssignmentAuditorCell from './AssignmentAuditorCell.vue';
import AssignmentAuditorFilter from './AssignmentAuditorFilter.vue';
import AssignmentImportConfirm from './AssignmentImportConfirm.vue';

import {
	buildAssignmentPair,
	dryRunImportAssignments,
	exportAssignments,
	fetchAssignments,
	fetchAssignmentsSummary,
	importAssignments,
	readImportFailure,
	saveAssignments,
} from '../../api/assignments';
import { MM_ASSIGNMENT_SORT_FIELDS } from '../../api/assignmentsWire';
import { fetchAuditorOptions } from '../../api/auditors';
import { fetchStoreLevels } from '../../api/catalog';
import { createCancelSource } from '../../api/mmHttp';
import {
	buildPageQuery,
	createPaginationState,
	createSortingState,
	MmPaginationState,
	MmSortingState,
	resolvePagerTotal,
} from '../../api/pagination';
import {
	MM_IMPORT_ALLOWED_EXTENSIONS,
	MM_IMPORT_MAX_FILE_BYTES,
	MM_IMPORT_TWO_STEP_CONFIRM,
	MM_SHOW_COMPETITOR_PRIORITY,
} from '../../config/features';
import { buildExportFileName, downloadBlob, readContentDispositionFileName } from '../../core/download';
import { isCanceled, MmError, toMmError, toMmErrorAsync, formatDiagnostics } from '../../core/errors';
import { orDash } from '../../core/format';
import { getSessionStore, retryMobileSession } from '../../core/session';
import { MmAuditor, MmSelectOption, MmStoreAuditorAssignment } from '../../types/domain';
import { MmAssignmentImportPreview, MmAssignmentListFilters, MmImportErrorDetails, MmStoreLevelsRequest } from '../../types/dto';
import { MmErrorCode } from '../../types/enums';

const KEY_PREFIX = 'priceMonitoring.mobileMonitoring.assignments.';

const SEARCH_DEBOUNCE_MS = 350;

/** Импорт связок: Apache POI + построчная запись — до 3 минут на файл. */
const IMPORT_REQUEST_TIMEOUT_MS = 180000;

const EXPORT_FILE_PREFIX = 'Экспорт_торговых_точек';
const IMPORT_ERRORS_FILE_PREFIX = 'Ошибки_загрузки_связок';

const EXPORT_MIME_EXTENSIONS: Array<{ marker: string; extension: string }> = [
	{ marker: 'spreadsheetml', extension: '.xlsx' },
	{ marker: 'ms-excel', extension: '.xls' },
	{ marker: 'csv', extension: '.csv' },
	{ marker: 'text/plain', extension: '.txt' },
];

/** Пустое расширение ломает обратную загрузку: файл без него отвергает своя же проверка */
const EXPORT_FALLBACK_EXTENSION = '.xlsx';

const COLUMN_WIDTHS = {
	format: 150,
	region: 150,
	cluster: 150,
	code: 250,
	name: 210,
	address: 250,
	priority: 120,
	auditor: 340,
};

type MmLevelType = 'format' | 'region' | 'cluster';

@Component({
	components: {
		Card,
		CollapseCard,
		ColumnTitleContent,
		MmErrorsPanel,
		MmFileUpload,
		MmHintedButton,
		MmStates,
		MmTable,
		MmZoneSelect,
		AssignmentAuditorCell,
		AssignmentAuditorFilter,
		AssignmentImportConfirm,
	},
})
export default class AssignmentsSection extends Mixins(Toast) {
	@Prop({ default: null }) readonly tradingId!: number | null;

	/** ant-design-vue 1.7.8 не размонтирует открытую вкладку, поэтому запросы идут только при isActive */
	@Prop({ default: false }) readonly isActive!: boolean;

	@Prop({ default: null }) readonly tradingName!: string | null;

	@Prop({ default: null }) readonly incomingFilters!: {
		formats?: number[];
		regions?: number[];
		clusters?: number[];
		onlyWithoutAuditor?: boolean;
	} | null;

	/** «Все» в интерфейсе — один тег, в модели пустой массив */
	formatValue: number[] = [];
	regionValue: number[] = [];
	clusterValue: number[] = [];

	auditorLoginsFilter: string[] = [];
	onlyWithoutAuditor: boolean = false;

	searchQuery: string = '';
	appliedQuery: string = '';

	competitorCodesFilter: string[] = [];

	private appliedFilterState: {
		formatValue: number[];
		regionValue: number[];
		clusterValue: number[];
		auditorLoginsFilter: string[];
		onlyWithoutAuditor: boolean;
		competitorCodesFilter: string[];
		appliedQuery: string;
	} | null = null;

	formatOptions: MmSelectOption[] = [];
	regionOptions: MmSelectOption[] = [];
	clusterOptions: MmSelectOption[] = [];

	isFormatsLoading: boolean = false;
	isRegionsLoading: boolean = false;
	isClustersLoading: boolean = false;

	auditorOptions: MmAuditor[] = [];
	isAuditorsLoading: boolean = false;
	auditorsErrorText: string = '';

	rows: MmStoreAuditorAssignment[] = [];
	pagination: MmPaginationState = createPaginationState();
	sorting: MmSortingState = createSortingState();
	isListLoading: boolean = false;
	listError: MmError | null = null;
	private hasLoadedOnce: boolean = false;

	summaryTotal: number | null = null;
	summaryWithoutAuditor: number | null = null;

	editingCode: string | null = null;
	savingCode: string | null = null;
	pendingEditPosition: string | null = null;
	/** Счётчик сессий правки: ответ из прошлой сессии не должен возвращать редактор на экран */
	editRunId: number = 0;

	private auditorEditDirty: boolean = false;

	isExporting: boolean = false;

	importFile: File | null = null;
	importFieldError: string = '';
	isDryRunning: boolean = false;
	isApplying: boolean = false;

	isConfirmVisible: boolean = false;
	importPreview: MmAssignmentImportPreview | null = null;

	importErrorLines: string[] = [];
	importErrorDetails: MmImportErrorDetails | null = null;
	isImportErrorsVisible: boolean = false;
	/** Поле, а не геттер: новая дата не реактивна, и штамп времени в имени файла замерзал бы */
	importErrorsFileName: string = '';

	private needsReload: boolean = false;
	private searchTimer: number | null = null;
	private listSource: any = null;
	private auditorsSource: any = null;
	private summarySource: any = null;
	private levelSources: { [key: string]: any } = { format: null, region: null, cluster: null };
	private documentMouseDownHandler: any = null;
	private assignmentFiltersHandler: any = null;

	mounted(): void {
		this.documentMouseDownHandler = (event: any) => this.handleDocumentMouseDown(event);
		document.addEventListener('mousedown', this.documentMouseDownHandler, true);

		this.assignmentFiltersHandler = (payload: any) => this.applyAssignmentFilters(payload);
		EventBus.$on(MM_APPLY_ASSIGNMENT_FILTERS, this.assignmentFiltersHandler);

		this.applyIncomingFiltersIfAny(this.incomingFilters);
		this.commitAppliedFilters();
		this.reloadAll();
	}

	beforeDestroy(): void {
		if (this.documentMouseDownHandler !== null) {
			document.removeEventListener('mousedown', this.documentMouseDownHandler, true);
			this.documentMouseDownHandler = null;
		}

		if (this.assignmentFiltersHandler !== null) {
			EventBus.$off(MM_APPLY_ASSIGNMENT_FILTERS, this.assignmentFiltersHandler);
			this.assignmentFiltersHandler = null;
		}

		this.clearSearchTimer();
		this.cancelPendingRequests();
	}

	@Watch('session.readyTick')
	onSessionReady(): void {
		if (!this.isActive) {
			this.needsReload = true;

			return;
		}

		this.reloadAll();
	}

	@Watch('isActive')
	onActiveChanged(next: boolean): void {
		if (next === true && this.needsReload) {
			this.needsReload = false;
			this.reloadAll();
		}
	}

	@Watch('incomingFilters')
	onIncomingFiltersChanged(next: {
		formats?: number[];
		regions?: number[];
		clusters?: number[];
		onlyWithoutAuditor?: boolean;
	} | null): void {
		if (next == null) {
			return;
		}

		this.applyAssignmentFilters(next);
	}

	get session() {
		return getSessionStore();
	}

	get isNetworkMissing(): boolean {
		return this.tradingId === null;
	}

	get networkMissingReason(): string {
		return this.$t('priceMonitoring.mobileMonitoring.states.networkNotSelected') as string;
	}

	get formatPlaceholder(): string {
		return this.isFormatsLoading ? (this.$t('regular.loading.formatsChannels') as string) : '';
	}

	get regionPlaceholder(): string {
		return this.isRegionsLoading ? (this.$t('regular.loading.regions') as string) : '';
	}

	get clusterPlaceholder(): string {
		return this.isClustersLoading ? (this.$t('regular.loading.clusters') as string) : '';
	}

	get countText(): string {
		return this.$t(KEY_PREFIX + 'countLabel', { count: this.pagination.total }) as string;
	}

	get hasSummary(): boolean {
		return this.summaryTotal !== null && this.summaryWithoutAuditor !== null;
	}

	get withoutAuditorText(): string {
		return this.$t(KEY_PREFIX + 'withoutAuditorLabel', {
			count: this.summaryWithoutAuditor === null ? 0 : this.summaryWithoutAuditor,
			total: this.summaryTotal === null ? 0 : this.summaryTotal,
		}) as string;
	}

	get hasCodesFilter(): boolean {
		return this.competitorCodesFilter.length > 0;
	}

	get codesFilterText(): string {
		return (this.$t(KEY_PREFIX + 'colCode') as string) + ': ' + String(this.competitorCodesFilter.length);
	}

	fieldLabelId(field: string): string {
		return 'sm-mobilemon-assignments-' + field + '-label-' + String((this as any)._uid);
	}

	get listFilters(): Partial<MmAssignmentListFilters> {
		const state = this.appliedFilterState != null
			? this.appliedFilterState
			: this.readCommittedAssignmentFilters();

		return {
			formats: state.formatValue.slice().realValuesOrEmpty(),
			regions: state.regionValue.slice().realValuesOrEmpty(),
			clusters: state.clusterValue.slice().realValuesOrEmpty(),
			groups: [],
			categories: [],
			subcategories: [],
			q: state.appliedQuery !== '' ? state.appliedQuery : null,
			competitorCodes: state.competitorCodesFilter.slice(),
			auditorLogins: state.auditorLoginsFilter.slice(),
			onlyWithoutAuditor: state.onlyWithoutAuditor,
		};
	}

	get filtersDirty(): boolean {
		if (this.appliedFilterState === null) {
			return false;
		}

		return JSON.stringify(this.readDraftAssignmentFilters()) !== JSON.stringify(this.appliedFilterState);
	}

	private readDraftAssignmentFilters(): {
		formatValue: number[];
		regionValue: number[];
		clusterValue: number[];
		auditorLoginsFilter: string[];
		onlyWithoutAuditor: boolean;
		competitorCodesFilter: string[];
		appliedQuery: string;
	} {
		return {
			formatValue: this.formatValue.slice(),
			regionValue: this.regionValue.slice(),
			clusterValue: this.clusterValue.slice(),
			auditorLoginsFilter: this.auditorLoginsFilter.slice(),
			onlyWithoutAuditor: this.onlyWithoutAuditor,
			competitorCodesFilter: this.competitorCodesFilter.slice(),
			appliedQuery: this.searchQuery.trim(),
		};
	}

	private readCommittedAssignmentFilters(): {
		formatValue: number[];
		regionValue: number[];
		clusterValue: number[];
		auditorLoginsFilter: string[];
		onlyWithoutAuditor: boolean;
		competitorCodesFilter: string[];
		appliedQuery: string;
	} {
		return {
			formatValue: this.formatValue.slice(),
			regionValue: this.regionValue.slice(),
			clusterValue: this.clusterValue.slice(),
			auditorLoginsFilter: this.auditorLoginsFilter.slice(),
			onlyWithoutAuditor: this.onlyWithoutAuditor,
			competitorCodesFilter: this.competitorCodesFilter.slice(),
			appliedQuery: this.appliedQuery,
		};
	}

	private commitAppliedFilters(): void {
		this.appliedQuery = this.searchQuery.trim();
		this.appliedFilterState = {
			formatValue: this.formatValue.slice(),
			regionValue: this.regionValue.slice(),
			clusterValue: this.clusterValue.slice(),
			auditorLoginsFilter: this.auditorLoginsFilter.slice(),
			onlyWithoutAuditor: this.onlyWithoutAuditor,
			competitorCodesFilter: this.competitorCodesFilter.slice(),
			appliedQuery: this.appliedQuery,
		};
	}

	/** Фильтр по аудитору вырезает вызывающий: иначе счётчик считал бы сам себя и давал «N из N» */
	get summaryFilters(): Partial<MmAssignmentListFilters> {
		const filters = this.listFilters;

		return {
			formats: filters.formats,
			regions: filters.regions,
			clusters: filters.clusters,
			groups: [],
			categories: [],
			subcategories: [],
			q: filters.q,
			competitorCodes: filters.competitorCodes,
			auditorLogins: [],
			onlyWithoutAuditor: false,
		};
	}

	get hasActiveFilters(): boolean {
		const filters = this.listFilters;

		return (filters.formats as number[]).length > 0
			|| (filters.regions as number[]).length > 0
			|| (filters.clusters as number[]).length > 0
			|| (filters.competitorCodes as string[]).length > 0
			|| (filters.auditorLogins as string[]).length > 0
			|| this.onlyWithoutAuditor
			|| this.appliedQuery !== '';
	}

	get rowKey(): (record: MmStoreAuditorAssignment) => string {
		return (record: MmStoreAuditorAssignment) => record.competitorCode;
	}

	/** Все колонки слотами: вложенный dataIndex уехал бы в запрос как имя поля сортировки */
	get columns(): any[] {
		const result: any[] = [
			/* Закрепление колонки работает только при заданном scroll.x и несовместимо с раскрытием строк */
			this.buildColumn('storeFormatName', 'colFormat', COLUMN_WIDTHS.format, 'formatCell', 'left'),
			this.buildColumn('storeRegionName', 'colRegion', COLUMN_WIDTHS.region, 'regionCell'),
			this.buildColumn('storeClusterName', 'colCluster', COLUMN_WIDTHS.cluster, 'clusterCell'),
			this.buildColumn('competitorCode', 'colCode', COLUMN_WIDTHS.code, 'codeCell'),
			this.buildColumn('name', 'colName', COLUMN_WIDTHS.name, 'nameCell'),
			this.buildColumn('address', 'colAddress', COLUMN_WIDTHS.address, 'addressCell'),
		];

		if (MM_SHOW_COMPETITOR_PRIORITY) {
			result.push(this.buildColumn('priority', 'colPriority', COLUMN_WIDTHS.priority, 'priorityCell'));
		}

		/** Ячейка при закреплении монтируется дважды */
		result.push(this.buildColumn('auditorLogin', 'colAuditor', COLUMN_WIDTHS.auditor, 'auditorCell', 'right'));

		return result;
	}

	get scrollX(): number {
		let total = COLUMN_WIDTHS.format
			+ COLUMN_WIDTHS.region
			+ COLUMN_WIDTHS.cluster
			+ COLUMN_WIDTHS.code
			+ COLUMN_WIDTHS.name
			+ COLUMN_WIDTHS.address
			+ COLUMN_WIDTHS.auditor;

		if (MM_SHOW_COMPETITOR_PRIORITY) {
			total += COLUMN_WIDTHS.priority;
		}

		return total;
	}

	readStoreText(row: MmStoreAuditorAssignment, field: string): string {
		const store: any = row && row.store ? row.store : null;

		return orDash(store ? store[field] : null);
	}

	/** title не задаём: узел из слота подставляется только там, где title === undefined */
	private buildColumn(key: string, titleKey: string, width: number, slotName: string, fixed?: string): any {
		const column: any = {
			key: key,
			slots: { title: key + 'ColumnTitle' },
			slotColumnTitleData: {
				text: this.$t(KEY_PREFIX + titleKey) as string,
			},
			width: width,
			sorter: true,
			sortOrder: this.readSortOrder(key),
			scopedSlots: { customRender: slotName },
		};

		// ant считает fixed заданным даже при undefined, поэтому ключ кладём только когда он есть
		if (fixed !== undefined) {
			column.fixed = fixed;
		}

		return column;
	}

	private readSortOrder(field: string): string | boolean {
		if (this.sorting.field !== field || this.sorting.order === null) {
			return false;
		}

		return this.sorting.order === 'desc' ? 'descend' : 'ascend';
	}

	get emptyStateName(): string {
		if (this.listError === null) {
			return 'empty';
		}

		if (this.listError.code === MmErrorCode.FORBIDDEN) {
			return 'forbidden';
		}

		/** UNAUTHORIZED сюда не добавлять: он лечится повторным обменом сессии, а не соединением */
		if (
			this.listError.code === MmErrorCode.SERVER
			|| this.listError.code === MmErrorCode.NETWORK
			|| this.listError.code === MmErrorCode.TIMEOUT
		) {
			return 'unavailable';
		}

		return 'error';
	}

	get emptyStateTitle(): string {
		if (this.emptyStateName === 'forbidden' || this.emptyStateName === 'unavailable') {
			return '';
		}

		if (this.listError !== null) {
			return this.$t(KEY_PREFIX + 'errorTitle') as string;
		}

		if (this.hasActiveFilters) {
			return this.$t(KEY_PREFIX + 'emptyFiltered') as string;
		}

		return this.$t(KEY_PREFIX + 'emptyTitle') as string;
	}

	get emptyStateText(): string {
		if (this.emptyStateName === 'forbidden') {
			return '';
		}

		if (this.listError !== null) {
			const message = this.listError.message ? String(this.listError.message).trim() : '';

			return message !== '' ? message : (this.$t(KEY_PREFIX + 'errorText') as string);
		}

		return '';
	}

	get isListErrorRetryable(): boolean {
		return this.listError !== null && this.listError.retryable;
	}

	/** Слот пустого состояния у MmTable во время загрузки не рисуется — показываем её в разметке */
	get isInitialLoading(): boolean {
		return this.isListLoading && !this.hasLoadedOnce;
	}

	get listErrorDiagnostics(): string {
		return this.listError !== null ? formatDiagnostics(this.listError.diagnostics) : '';
	}

	get showResetCta(): boolean {
		return this.listError === null && this.hasActiveFilters;
	}

	/** Кнопку рисуем, только если на её событие кто-то подписан, иначе нажатие ничего не сделает */
	get showAuditorsCta(): boolean {
		return this.hasNoAuditors && !!(this.$listeners && this.$listeners['go-to-auditors']);
	}

	get hasNoAuditors(): boolean {
		return !this.isAuditorsLoading && this.auditorsErrorText === '' && this.auditorOptions.length === 0;
	}

	private reloadAll(): void {
		if (this.tradingId === null) {
			return;
		}

		this.exitEditing();
		this.loadLevel('format');
		this.loadLevel('region');
		this.loadLevel('cluster');

		Promise.all([
			this.loadAssignments().catch(() => undefined),
			this.loadAuditors().catch(() => undefined),
		]).catch(() => undefined);

		this.refreshSummary();
	}

	private loadAssignments(): Promise<void> {
		if (this.tradingId === null) {
			return Promise.resolve();
		}

		if (this.listSource !== null) {
			this.listSource.cancel();
		}

		const source = createCancelSource();

		this.listSource = source;
		this.isListLoading = true;

		return fetchAssignments(
			this.tradingId,
			this.listFilters,
			buildPageQuery(this.pagination, this.sorting, MM_ASSIGNMENT_SORT_FIELDS),
			{ cancelToken: source.token },
		)
			.then((page) => {
				/** Флаг поднимаем здесь, а не в finally: следующему шагу нужна уже отрисованная таблица */
				this.hasLoadedOnce = true;
				this.rows = page.content ? page.content : [];
				this.resolveRowAuditorLabels();
				this.pagination.total = resolvePagerTotal(page, this.pagination);
				this.listError = null;
				this.applyPendingEditPosition();
				this.repageToLastPage();
			})
			.catch((error) => {
				if (isCanceled(error)) {
					return;
				}

				this.hasLoadedOnce = true;
				this.rows = [];
				this.pagination.total = 0;
				this.listError = toMmError(error, 'assignments/list');
				this.pendingEditPosition = null;
				this.editingCode = null;
			})
			.finally(() => {
				if (this.listSource === source) {
					this.listSource = null;
					this.isListLoading = false;
				}
			});
	}

	private repageToLastPage(): void {
		const size = this.pagination.pageSize;

		if (size <= 0 || this.pagination.current <= 1) {
			return;
		}

		const pageCount = Math.ceil(this.pagination.total / size);
		const lastPage = pageCount > 0 ? pageCount : 1;

		if (this.pagination.current <= lastPage) {
			return;
		}

		this.pagination.current = lastPage;
		this.listSource = null;
		this.loadAssignments();
	}

	private loadAuditors(): Promise<void> {
		if (this.tradingId === null) {
			return Promise.resolve();
		}

		if (this.auditorsSource !== null) {
			this.auditorsSource.cancel();
		}

		const source = createCancelSource();

		this.auditorsSource = source;
		this.isAuditorsLoading = true;
		this.auditorsErrorText = '';

		return fetchAuditorOptions({ cancelToken: source.token })
			.then((response) => {
				if (this.auditorsSource !== source) {
					return;
				}

				this.auditorOptions = Array.isArray(response.data) ? response.data : [];

				/* Второй пересчёт подписей на случай, когда справочник аудиторов приходит позже строк */
				this.resolveRowAuditorLabels();
			})
			.catch((error) => {
				if (isCanceled(error) || this.auditorsSource !== source) {
					return;
				}

				this.auditorOptions = [];
				this.auditorsErrorText = this.$t(KEY_PREFIX + 'auditorsLoadError') as string;
			})
			.finally(() => {
				if (this.auditorsSource !== source) {
					return;
				}

				this.auditorsSource = null;
				this.isAuditorsLoading = false;
			});
	}

	/** Отказ фоновой сводки не показываем уведомлением, счётчик гасим: числа уже от другой выборки */
	private refreshSummary(): void {
		if (this.tradingId === null) {
			return;
		}

		if (this.summarySource !== null) {
			this.summarySource.cancel();
		}

		const source = createCancelSource();

		this.summarySource = source;

		fetchAssignmentsSummary(this.tradingId, this.summaryFilters, { cancelToken: source.token })
			.then((response) => {
				const data = response.data;

				if (!data) {
					return;
				}

				this.summaryTotal = typeof data.total === 'number' ? data.total : null;
				this.summaryWithoutAuditor = typeof data.withoutAuditor === 'number' ? data.withoutAuditor : null;
			})
			.catch((error) => {
				if (isCanceled(error) || this.summarySource !== source) {
					return;
				}

				this.summaryTotal = null;
				this.summaryWithoutAuditor = null;
			})
			.finally(() => {
				if (this.summarySource === source) {
					this.summarySource = null;
				}
			});
	}

	private buildLevelsRequest(type: MmLevelType): MmStoreLevelsRequest {
		const formats = this.formatValue.slice().realValuesOrEmpty();
		const regions = this.regionValue.slice().realValuesOrEmpty();

		return {
			tradingNetworkId: this.tradingId as number,
			type: type,
			storeFormat: type === 'format' ? [] : formats,
			storeRegion: type === 'cluster' ? regions : [],
			storeCluster: [],
		};
	}

	private loadLevel(type: MmLevelType): void {
		if (this.tradingId === null) {
			return;
		}

		const previous = this.levelSources[type];

		if (previous) {
			previous.cancel();
		}

		const source = createCancelSource();

		this.levelSources[type] = source;
		this.setLevelLoading(type, true);

		fetchStoreLevels(this.buildLevelsRequest(type), { cancelToken: source.token })
			.then((response) => {
				const data = response.data;
				const items = data && Array.isArray(data.items) ? data.items : [];

				this.setLevelOptions(type, items.length > 0 ? items : this.buildAllOnlyOptions());
			})
			.catch((error) => {
				if (isCanceled(error)) {
					return;
				}

				this.setLevelOptions(type, this.buildAllOnlyOptions());
				this.showError(this.$t('http.errors.loadFilters3') as string);
			})
			.finally(() => {
				if (this.levelSources[type] === source) {
					this.levelSources[type] = null;
					this.setLevelLoading(type, false);
				}
			});
	}

	private buildAllOnlyOptions(): MmSelectOption[] {
		return [{ value: 0, label: this.$t('shared.selectBox.all') as string }];
	}

	private setLevelOptions(type: MmLevelType, items: MmSelectOption[]): void {
		if (type === 'format') {
			this.formatOptions = items;

			return;
		}

		if (type === 'region') {
			this.regionOptions = items;

			return;
		}

		this.clusterOptions = items;
	}

	private setLevelLoading(type: MmLevelType, value: boolean): void {
		if (type === 'format') {
			this.isFormatsLoading = value;

			return;
		}

		if (type === 'region') {
			this.isRegionsLoading = value;

			return;
		}

		this.isClustersLoading = value;
	}

	/** Сравниваем отсортированные копии: MultiSelect шлёт событие и на программную установку — иначе цикл */
	handleFormatChange(next: number[]): void {
		const value = next ? next : [];

		if (this.isSameIdList(value, this.formatValue)) {
			return;
		}

		this.formatValue = value.slice();
		this.regionValue = [];
		this.clusterValue = [];
		this.loadLevel('region');
		this.loadLevel('cluster');
	}

	handleRegionChange(next: number[]): void {
		const value = next ? next : [];

		if (this.isSameIdList(value, this.regionValue)) {
			return;
		}

		this.regionValue = value.slice();
		this.clusterValue = [];
		this.loadLevel('cluster');
	}

	handleClusterChange(next: number[]): void {
		const value = next ? next : [];

		if (this.isSameIdList(value, this.clusterValue)) {
			return;
		}

		this.clusterValue = value.slice();
	}

	private isSameIdList(a: number[], b: number[]): boolean {
		if (a.length !== b.length) {
			return false;
		}

		const left = a.slice().sort();
		const right = b.slice().sort();

		for (let i = 0; i < left.length; i += 1) {
			if (left[i] !== right[i]) {
				return false;
			}
		}

		return true;
	}

	/** Режим правки гасим здесь: после смены фильтра строка может выпасть из выборки */
	private applyFilterChange(): void {
		this.exitEditing();
		this.pagination.current = 1;
		this.loadAssignments();
		this.refreshSummary();
	}

	handleAuditorFilterChange(payload: { logins: string[]; unassigned: boolean }): void {
		this.auditorLoginsFilter = payload && payload.logins ? payload.logins.slice() : [];
		this.onlyWithoutAuditor = !!(payload && payload.unassigned);
	}

	handleRetryAuditors(): void {
		this.loadAuditors().catch(() => undefined);
	}

	handleShowWithoutAuditor(): void {
		if (this.onlyWithoutAuditor) {
			return;
		}

		this.onlyWithoutAuditor = true;
	}

	handleClearCodesFilter(): void {
		if (!this.hasCodesFilter) {
			return;
		}

		this.competitorCodesFilter = [];
	}

	handleResetFilters(): void {
		if (this.auditorEditDirty) {
			return;
		}

		this.clearSearchTimer();

		this.formatValue = [];
		this.regionValue = [];
		this.clusterValue = [];
		this.auditorLoginsFilter = [];
		this.onlyWithoutAuditor = false;
		this.competitorCodesFilter = [];
		this.searchQuery = '';
		this.appliedQuery = '';

		this.loadLevel('region');
		this.loadLevel('cluster');

		this.commitAppliedFilters();
		this.applyFilterChange();
	}

	applyAssignmentFilters(payload: {
		formats?: number[];
		regions?: number[];
		clusters?: number[];
		onlyWithoutAuditor?: boolean;
	} | null): void {
		if (payload == null || !this.payloadHasAssignmentFilters(payload)) {
			this.$emit('assignment-filters-applied');

			return;
		}

		this.writeFiltersFromPayload(payload);
		this.loadLevel('region');
		this.loadLevel('cluster');
		this.commitAppliedFilters();
		this.applyFilterChange();
		this.$emit('assignment-filters-applied');
	}

	private applyIncomingFiltersIfAny(payload: {
		formats?: number[];
		regions?: number[];
		clusters?: number[];
		onlyWithoutAuditor?: boolean;
	} | null): void {
		if (payload == null) {
			return;
		}

		if (this.payloadHasAssignmentFilters(payload)) {
			this.writeFiltersFromPayload(payload);
		}

		this.$emit('assignment-filters-applied');
	}

	private payloadHasAssignmentFilters(payload: {
		formats?: number[];
		regions?: number[];
		clusters?: number[];
		onlyWithoutAuditor?: boolean;
	}): boolean {
		return (Object.prototype.hasOwnProperty.call(payload, 'formats') && Array.isArray(payload.formats))
			|| (Object.prototype.hasOwnProperty.call(payload, 'regions') && Array.isArray(payload.regions))
			|| (Object.prototype.hasOwnProperty.call(payload, 'clusters') && Array.isArray(payload.clusters))
			|| payload.onlyWithoutAuditor === true;
	}

	private writeFiltersFromPayload(payload: {
		formats?: number[];
		regions?: number[];
		clusters?: number[];
		onlyWithoutAuditor?: boolean;
	} | null): boolean {
		if (payload == null) {
			return false;
		}

		let changed = false;

		if (Object.prototype.hasOwnProperty.call(payload, 'formats') && Array.isArray(payload.formats)) {
			const next = this.readFilterIdList(payload.formats);

			if (!this.isSameIdList(next, this.formatValue)) {
				this.formatValue = next;
				changed = true;
			}
		}

		if (Object.prototype.hasOwnProperty.call(payload, 'regions') && Array.isArray(payload.regions)) {
			const next = this.readFilterIdList(payload.regions);

			if (!this.isSameIdList(next, this.regionValue)) {
				this.regionValue = next;
				changed = true;
			}
		}

		if (Object.prototype.hasOwnProperty.call(payload, 'clusters') && Array.isArray(payload.clusters)) {
			const next = this.readFilterIdList(payload.clusters);

			if (!this.isSameIdList(next, this.clusterValue)) {
				this.clusterValue = next;
				changed = true;
			}
		}

		if (payload.onlyWithoutAuditor === true && !this.onlyWithoutAuditor) {
			this.onlyWithoutAuditor = true;
			changed = true;
		}

		return changed;
	}

	private readFilterIdList(raw: any[]): number[] {
		const result: number[] = [];

		for (let i = 0; i < raw.length; i += 1) {
			const value = raw[i];
			const n = typeof value === 'number' ? value : Number(value);

			if (isFinite(n) && n !== 0 && n !== -1) {
				result.push(n);
			}
		}

		return result;
	}

	handleSearchInput(event: any): void {
		const value = event && event.target ? String(event.target.value) : '';

		this.searchQuery = value;
		this.clearSearchTimer();
	}

	handleSearchSubmit(): void {
		this.clearSearchTimer();
	}

	private clearSearchTimer(): void {
		if (this.searchTimer !== null) {
			window.clearTimeout(this.searchTimer);
			this.searchTimer = null;
		}
	}

	handleRefresh(): void {
		if (this.auditorEditDirty) {
			return;
		}

		this.exitEditing();
		this.commitAppliedFilters();
		this.applyFilterChange();
	}

	handleTableChange(event: { pagination: MmPaginationState; sorter: MmSortingState; filters: any }): void {
		if (this.auditorEditDirty) {
			return;
		}

		this.exitEditing();

		this.pagination.current = event.pagination.current;
		this.pagination.pageSize = event.pagination.pageSize;
		this.sorting = { field: event.sorter.field, order: event.sorter.order };

		this.loadAssignments();
	}

	handleRetryList(): void {
		if (this.listError !== null && this.listError.code === MmErrorCode.UNAUTHORIZED) {
			retryMobileSession();

			return;
		}

		this.loadAssignments();
		this.refreshSummary();
	}

	handleGoToAuditors(): void {
		this.$emit('go-to-auditors');
	}

	get isEditDisabled(): boolean {
		return this.tradingId === null || this.isAuditorsLoading || this.auditorOptions.length === 0;
	}

	get editDisabledReason(): string {
		if (this.tradingId === null) {
			return this.networkMissingReason;
		}

		if (this.isAuditorsLoading) {
			return this.$t('priceMonitoring.mobileMonitoring.states.loading') as string;
		}

		if (this.auditorsErrorText !== '') {
			return this.auditorsErrorText;
		}

		return this.$t(KEY_PREFIX + 'emptyNoAuditors') as string;
	}

	handleStartEdit(row: MmStoreAuditorAssignment): void {
		if (this.isEditDisabled) {
			return;
		}

		if (this.savingCode !== null) {
			return;
		}

		if (this.auditorEditDirty && this.editingCode !== null && this.editingCode !== row.competitorCode) {
			return;
		}

		this.editingCode = row.competitorCode;
		this.editRunId += 1;
		this.auditorEditDirty = false;
	}

	handleCancelEdit(): void {
		this.exitEditing();
	}

	handleAuditorDirty(isDirty: boolean): void {
		this.auditorEditDirty = isDirty === true;
	}

	/** Оптимистично с откатом; auditorId null — это «снять аудитора», сравнение только sameAuditorId */
	handleAuditorChange(row: MmStoreAuditorAssignment, auditorId: number | string | null): void {
		if (this.tradingId === null || this.savingCode !== null) {
			return;
		}

		const previousId: number | string | null = row.auditorId != null ? row.auditorId : null;

		if (this.sameAuditorId(previousId, auditorId)) {
			this.moveEditingToNext(row.competitorCode);

			return;
		}

		const previousLogin = row.auditorLogin;
		const previousFullName = row.auditorFullName;

		/** Идентификатор аудитора уходит как есть: Number() потерял бы строковый идентификатор */
		const pair = buildAssignmentPair(row, auditorId);

		/** Ответ двигает режим правки только в той же сессии: иначе он перетащит фокус из другого поля */
		const runId = this.editRunId;

		this.applyAuditorToRow(row, auditorId);
		this.savingCode = row.competitorCode;

		saveAssignments(this.tradingId, [pair])
			.then(() => {
				this.updateSummaryAfterSave(previousId, auditorId);
				this.refreshSummary();
				this.auditorEditDirty = false;
				this.showAuditorSaveToast(previousId, auditorId);

				if (this.isSameEditSession(runId, row.competitorCode)) {
					this.moveEditingToNext(row.competitorCode);
				}
			})
			.catch((error) => {
				if (isCanceled(error)) {
					return;
				}

				this.$set(row, 'auditorId', previousId);
				this.$set(row, 'auditorLogin', previousLogin);
				this.$set(row, 'auditorFullName', previousFullName);

				const mmError = toMmError(error, 'assignments/save');
				const serverText = mmError.message ? String(mmError.message).trim() : '';
				const baseText = this.$t(KEY_PREFIX + 'saveRowError', { code: row.competitorCode }) as string;

				this.showError(serverText !== '' ? baseText + ' ' + serverText : baseText);

				if (this.isSameEditSession(runId, row.competitorCode)) {
					this.editingCode = row.competitorCode;
					this.auditorEditDirty = true;
				}
			})
			.finally(() => {
				this.savingCode = null;
			});
	}

	private isSameEditSession(runId: number, competitorCode: string): boolean {
		return this.editRunId === runId && this.editingCode === competitorCode;
	}

	handleConfirmRow(row: MmStoreAuditorAssignment, auditorId: number | string | null): void {
		if (this.savingCode !== null) {
			return;
		}

		this.handleAuditorChange(row, auditorId);
	}

	private showAuditorSaveToast(previousId: number | string | null, nextId: number | string | null): void {
		const wasEmpty = previousId == null;
		const isEmpty = nextId == null;

		if (isEmpty && !wasEmpty) {
			this.showInfo(this.$t(KEY_PREFIX + 'auditorCleared') as string);

			return;
		}

		if (!isEmpty) {
			this.showInfo(this.$t(KEY_PREFIX + 'auditorAssigned') as string);
		}
	}

	handleNav(row: MmStoreAuditorAssignment, direction: string): void {
		if (this.savingCode !== null || this.auditorEditDirty) {
			return;
		}

		const index = this.findRowIndex(row.competitorCode);

		if (index < 0) {
			return;
		}

		if (direction === 'up') {
			if (index > 0) {
				this.editingCode = this.rows[index - 1].competitorCode;

				return;
			}

			if (this.pagination.current > 1) {
				this.goToPageKeepingEditing(this.pagination.current - 1, 'last');
			}

			return;
		}

		if (index + 1 < this.rows.length) {
			this.editingCode = this.rows[index + 1].competitorCode;

			return;
		}

		if (this.hasNextPage) {
			this.goToPageKeepingEditing(this.pagination.current + 1, 'first');
		}
	}

	private moveEditingToNext(code: string): void {
		this.auditorEditDirty = false;
		const index = this.findRowIndex(code);

		if (index >= 0 && index + 1 < this.rows.length) {
			this.editingCode = this.rows[index + 1].competitorCode;

			return;
		}

		if (this.hasNextPage) {
			this.goToPageKeepingEditing(this.pagination.current + 1, 'first');

			return;
		}

		this.editingCode = null;
	}

	get hasNextPage(): boolean {
		return this.pagination.current * this.pagination.pageSize < this.pagination.total;
	}

	private goToPageKeepingEditing(page: number, position: string): void {
		this.editingCode = null;
		this.pendingEditPosition = position;
		this.pagination.current = page;
		this.loadAssignments();
	}

	private applyPendingEditPosition(): void {
		if (this.pendingEditPosition === 'first' && this.rows.length > 0) {
			this.editingCode = this.rows[0].competitorCode;
		} else if (this.pendingEditPosition === 'last' && this.rows.length > 0) {
			this.editingCode = this.rows[this.rows.length - 1].competitorCode;
		} else if (this.editingCode !== null && this.findRowIndex(this.editingCode) < 0) {
			this.editingCode = null;
		}

		this.pendingEditPosition = null;
	}

	private exitEditing(): void {
		this.editingCode = null;
		this.pendingEditPosition = null;
		this.auditorEditDirty = false;

		// Счётчик сессии правки растёт: поздний ответ сохранения не вернёт редактор и не заберёт фокус
		this.editRunId += 1;
	}

	private findRowIndex(code: string): number {
		for (let i = 0; i < this.rows.length; i += 1) {
			if (this.rows[i].competitorCode === code) {
				return i;
			}
		}

		return -1;
	}

	private resolveRowAuditorLabels(): void {
		if (this.auditorOptions.length === 0) {
			return;
		}

		for (let i = 0; i < this.rows.length; i += 1) {
			const row = this.rows[i];

			if (row.auditorId == null) {
				continue;
			}

			const auditor = this.findAuditor(row.auditorId);

			if (auditor !== null) {
				this.$set(row, 'auditorLogin', auditor.login);
				this.$set(row, 'auditorFullName', auditor.fullName);
			}
		}
	}

	private applyAuditorToRow(row: MmStoreAuditorAssignment, auditorId: number | string | null): void {
		// `== null` — и `null`, и `undefined`: «снять аудитора» приходит обоими.
		const auditor = auditorId == null ? null : this.findAuditor(auditorId);

		this.$set(row, 'auditorId', auditorId);
		this.$set(row, 'auditorLogin', auditor !== null ? auditor.login : null);
		this.$set(row, 'auditorFullName', auditor !== null ? auditor.fullName : null);
	}

	/** id аудитора бывает и строкой, и числом: сравнивать только так, Number() к нему не применять */
	private sameAuditorId(left: number | string | null, right: number | string | null): boolean {
		const isLeftEmpty = left == null;
		const isRightEmpty = right == null;

		if (isLeftEmpty || isRightEmpty) {
			return isLeftEmpty && isRightEmpty;
		}

		return String(left) === String(right);
	}

	private findAuditor(auditorId: number | string | null): MmAuditor | null {
		for (let i = 0; i < this.auditorOptions.length; i += 1) {
			if (this.sameAuditorId(this.auditorOptions[i].id, auditorId)) {
				return this.auditorOptions[i];
			}
		}

		return null;
	}

	/** Проверяем через == null: снятие приходит и как null, и как undefined */
	private updateSummaryAfterSave(previousId: number | string | null, nextId: number | string | null): void {
		if (this.summaryWithoutAuditor === null) {
			return;
		}

		let value = this.summaryWithoutAuditor;

		if (previousId == null && nextId != null) {
			value -= 1;
		} else if (previousId != null && nextId == null) {
			value += 1;
		} else {
			return;
		}

		const ceiling = this.summaryTotal !== null ? this.summaryTotal : value;

		this.summaryWithoutAuditor = Math.min(Math.max(value, 0), Math.max(ceiling, 0));
	}

	private handleDocumentMouseDown(event: any): void {
		if (this.editingCode === null) {
			return;
		}

		if (this.isInsideEditor(event ? event.target : null)) {
			return;
		}

		if (this.auditorEditDirty) {
			return;
		}

		this.exitEditing();
	}

	private isInsideEditor(target: any): boolean {
		let node: any = target;

		while (node) {
			const className = node.className;

			// className, а не classList: у SVG внутри иконок ant это SVGAnimatedString
			if (typeof className === 'string'
				&& (className.indexOf('sm-mobilemon__assign-editor') >= 0
					|| className.indexOf('ant-select-dropdown') >= 0)) {
				return true;
			}

			node = node.parentNode;
		}

		return false;
	}

	/** При responseType blob телом ошибки приходит Blob — разбирать только через toMmErrorAsync */
	handleExport(): void {
		if (this.tradingId === null || this.isExporting) {
			return;
		}

		this.isExporting = true;

		exportAssignments(this.tradingId, this.listFilters)
			.then((response) => {
				const blob = response.data as Blob;

				if (!blob || blob.size === 0) {
					this.showInfo(this.$t(KEY_PREFIX + 'exportEmpty') as string);

					return;
				}

				const headerName = readContentDispositionFileName(response.headers);
				const fileName = headerName !== null && headerName !== ''
					? headerName
					: buildExportFileName(EXPORT_FILE_PREFIX, this.tradingName, this.readExportExtension(blob));

				downloadBlob(blob, fileName);
			})
			.catch((error) => {
				if (isCanceled(error)) {
					return undefined;
				}

				return toMmErrorAsync(error, 'assignments/export').then((mmError) => {
					const message = mmError.message ? String(mmError.message).trim() : '';

					this.showError(message !== '' ? message : (this.$t(KEY_PREFIX + 'exportError') as string));
				});
			})
			.finally(() => {
				this.isExporting = false;
			});
	}

	private readExportExtension(blob: Blob): string {
		const type = blob && blob.type ? String(blob.type).toLowerCase() : '';

		if (type === '') {
			return EXPORT_FALLBACK_EXTENSION;
		}

		for (let i = 0; i < EXPORT_MIME_EXTENSIONS.length; i += 1) {
			if (type.indexOf(EXPORT_MIME_EXTENSIONS[i].marker) >= 0) {
				return EXPORT_MIME_EXTENSIONS[i].extension;
			}
		}

		return EXPORT_FALLBACK_EXTENSION;
	}

	get acceptAttribute(): string {
		return MM_IMPORT_ALLOWED_EXTENSIONS.join(',');
	}

	get isImportBusy(): boolean {
		return this.isDryRunning || this.isApplying;
	}

	get isFileFieldDisabled(): boolean {
		return this.isNetworkMissing || this.isImportBusy;
	}

	get fileFieldDisabledReason(): string {
		if (this.isNetworkMissing) {
			return this.networkMissingReason;
		}

		return this.$t('priceMonitoring.mobileMonitoring.states.loading') as string;
	}

	get isImportDisabled(): boolean {
		return this.isNetworkMissing || this.importFile === null;
	}

	get importDisabledReason(): string {
		if (this.isNetworkMissing) {
			return this.networkMissingReason;
		}

		return this.$t(KEY_PREFIX + 'importErrNoFile') as string;
	}

	get problemCodes(): string[] {
		const details = this.importErrorDetails;

		if (details === null) {
			return [];
		}

		const seen: { [key: string]: boolean } = {};
		const result: string[] = [];
		const source = details.unknownCompetitorCodes.concat(details.duplicateCompetitorCodes);

		for (let i = 0; i < source.length; i += 1) {
			const code = String(source[i]);

			if (code !== '' && seen[code] !== true) {
				seen[code] = true;
				result.push(code);
			}
		}

		return result;
	}

	get hasProblemCodes(): boolean {
		return this.problemCodes.length > 0;
	}

	handleFileSelected(file: File | null): void {
		this.importFile = file;
		this.importFieldError = '';
	}

	private validateImportFile(): string {
		const file = this.importFile;

		if (file === null) {
			return this.$t(KEY_PREFIX + 'importErrNoFile') as string;
		}

		if (!this.hasAllowedExtension(file.name)) {
			return this.$t(KEY_PREFIX + 'importErrExtension', {
				extensions: MM_IMPORT_ALLOWED_EXTENSIONS.join(', '),
			}) as string;
		}

		if (file.size === 0) {
			return this.$t(KEY_PREFIX + 'importErrEmptyFile') as string;
		}

		if (file.size > MM_IMPORT_MAX_FILE_BYTES) {
			return this.$t(KEY_PREFIX + 'importErrSize', { limit: this.maxFileSizeText }) as string;
		}

		return '';
	}

	private hasAllowedExtension(fileName: string): boolean {
		const name = fileName ? String(fileName).toLowerCase() : '';

		for (let i = 0; i < MM_IMPORT_ALLOWED_EXTENSIONS.length; i += 1) {
			const extension = MM_IMPORT_ALLOWED_EXTENSIONS[i];

			if (name.length > extension.length && name.substr(name.length - extension.length) === extension) {
				return true;
			}
		}

		return false;
	}

	get maxFileSizeText(): string {
		const megabytes = Math.round(MM_IMPORT_MAX_FILE_BYTES / (1024 * 1024));
		const units = this.$t('aiAssistant.fileUnits') as unknown as string[];
		const unit = Array.isArray(units) && units.length > 2 ? String(units[2]).trim() : '';

		return unit !== '' ? String(megabytes) + ' ' + unit : String(megabytes);
	}

	handleImportClick(): void {
		const error = this.validateImportFile();

		if (error !== '') {
			this.importFieldError = error;

			return;
		}

		this.importFieldError = '';

		this.clearImportErrors();

		if (MM_IMPORT_TWO_STEP_CONFIRM) {
			this.runDryRun();

			return;
		}

		this.runImport();
	}

	/** В конфиг кладём только timeout: свой params стёр бы флаг проверки и файл ушёл бы в базу */
	private runDryRun(): void {
		const file = this.importFile;

		if (this.tradingId === null || file === null || this.isImportBusy) {
			return;
		}

		this.isDryRunning = true;

		dryRunImportAssignments(this.tradingId, file, { timeout: IMPORT_REQUEST_TIMEOUT_MS })
			.then((response) => {
				this.importPreview = response.data ? response.data : null;
				this.isConfirmVisible = true;
			})
			.catch((error) => {
				this.handleImportFailure(error, 'assignments/import-dry-run');
			})
			.finally(() => {
				this.isDryRunning = false;
			});
	}

	/** Пишет в базу без отката; imported — число реально изменённых связок, а не строк файла */
	private runImport(): void {
		const file = this.importFile;

		if (this.tradingId === null || file === null || this.isApplying) {
			return;
		}

		this.isApplying = true;

		importAssignments(this.tradingId, file, { timeout: IMPORT_REQUEST_TIMEOUT_MS })
			.then((response) => {
				const data = response.data;
				const imported = data && typeof data.imported === 'number' ? data.imported : 0;

				this.isConfirmVisible = false;
				this.importPreview = null;
				this.clearImportErrors();
				this.resetImportFile();

				if (imported > 0) {
					this.showInfo(this.$t(KEY_PREFIX + 'importSuccess', { count: imported }) as string);
					this.showInfo(this.$t(KEY_PREFIX + 'importSuccessTasks') as string);
				} else {
					this.showInfo(this.$t(KEY_PREFIX + 'importSuccessNoChanges') as string);
				}

				this.exitEditing();
				this.loadAssignments();
				this.refreshSummary();
			})
			.catch((error) => {
				this.handleImportFailure(error, 'assignments/import');
			})
			.finally(() => {
				this.isApplying = false;
			});
	}

	handleConfirmApply(): void {
		this.runImport();
	}

	handleConfirmCancel(): void {
		this.isConfirmVisible = false;
		this.importPreview = null;
	}

	/** Выбор файла сбрасываем: иначе повторный выбор того же файла не даст события change */
	private handleImportFailure(error: any, section: string): void {
		if (isCanceled(error)) {
			return;
		}

		this.isConfirmVisible = false;
		this.importPreview = null;

		const failure = readImportFailure(error);

		if (failure === null) {
			this.showTransportImportError(error, section);

			return;
		}

		const lines: string[] = [];
		const message = failure.message ? String(failure.message).trim() : '';

		if (message !== '') {
			lines.push(message);
		}

		const parts = failure.errorsText.split('\n');

		for (let i = 0; i < parts.length; i += 1) {
			if (String(parts[i]).trim() !== '') {
				lines.push(parts[i]);
			}
		}

		this.importErrorLines = lines;
		this.importErrorDetails = failure.details;
		this.importErrorsFileName = buildExportFileName(IMPORT_ERRORS_FILE_PREFIX, this.tradingName, '.txt');
		this.isImportErrorsVisible = true;
		this.resetImportFile();
	}

	private showTransportImportError(error: any, section: string): void {
		const mmError = toMmError(error, section);
		const isApplyStep = section === 'assignments/import';

		if (isApplyStep && mmError.retryable) {
			this.showError(this.$t(KEY_PREFIX + 'importApplyUnknown') as string);
			this.resetImportFile();
			this.exitEditing();
			this.loadAssignments();
			this.refreshSummary();

			return;
		}

		const message = mmError.message ? String(mmError.message).trim() : '';

		this.showError(message !== '' ? message : (this.$t(mmError.i18nKey) as string));

		if (!mmError.retryable) {
			this.resetImportFile();
		}
	}

	/** Сброс через reset(): обнуление модели не чистит поле файла, и тот же файл не даст события */
	private resetImportFile(): void {
		const upload = this.$refs.upload as any;

		if (upload && typeof upload.reset === 'function') {
			upload.reset();
		}

		this.importFile = null;
		this.importFieldError = '';
	}

	clearImportErrors(): void {
		this.importErrorLines = [];
		this.importErrorDetails = null;
		this.importErrorsFileName = '';
		this.isImportErrorsVisible = false;
	}

	handleShowProblemCodes(): void {
		const codes = this.problemCodes;

		if (codes.length === 0) {
			return;
		}

		this.competitorCodesFilter = codes;
	}

	private cancelPendingRequests(): void {
		if (this.auditorsSource !== null) {
			this.auditorsSource.cancel();
			this.auditorsSource = null;
		}

		if (this.listSource !== null) {
			this.listSource.cancel();
			this.listSource = null;
		}

		if (this.summarySource !== null) {
			this.summarySource.cancel();
			this.summarySource = null;
		}

		const types: MmLevelType[] = ['format', 'region', 'cluster'];

		for (let i = 0; i < types.length; i += 1) {
			const source = this.levelSources[types[i]];

			if (source) {
				source.cancel();
				this.levelSources[types[i]] = null;
			}
		}
	}
}
